import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { SessionStorageService, LocalStorageService, } from 'angular-web-storage';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiIntegration {

  header1: any;
  headerWOAuth: any;

  constructor(private http: HttpClient) {
    let sessionJWT = localStorage.getItem('jwt');
    this.header1 = new HttpHeaders();
    this.header1 = this.header1.append('Content-Type', 'application/json');
    this.header1 = this.header1.append('Accept', 'application/json');
    if (sessionJWT) {
      this.header1 = this.header1.append('Authorization', 'Bearer ' + sessionJWT);
    }
    console.log(sessionJWT);
    this.headerWOAuth = new HttpHeaders();
    this.headerWOAuth = this.headerWOAuth.append('Content-Type', 'application/json');
    this.headerWOAuth = this.headerWOAuth.append('Accept', 'application/json');
  }

  getValues(orgId, controlId, parent, child) {
  var header1 = new HttpHeaders();
            header1 = header1.append('Content-Type', 'application/json');
            header1 = header1.append('Accept', 'application/json');
            header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    return this.http.get(environment.apiUrl + "api/getAllByControl?control=" + controlId + "&parent=" + parent + "&child=" + child + "&organizationId=" + orgId, {headers: header1});
  }


  getValuesPublic(orgId, controlId, parent, child) {
          var header1 = new HttpHeaders();
          header1 = header1.append('Content-Type', 'application/json');
          header1 = header1.append('Accept', 'application/json');
          header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
      return this.http.get(environment.apiUrl + "api/public/getAllByControl?control=" + controlId + "&parent=" + parent + "&child=" + child + "&organizationId=" + orgId, {headers: header1} );
    }


  getDays(orgId, controlId, parent, child) {
    return this.http.get(environment.apiUrl + "api/getReturnDays?control=" + controlId + "&parent=" + parent + "&child=" + child + "&organizationId=" + orgId, { headers: this.headerWOAuth });
  }

  getStatus(orgId, status) {
    return this.http.get(environment.apiUrl + "api/notifications/" + orgId + "/" + status, { headers: this.header1 });
  }

  getAllNotifications(orgId) {
    return this.http.get(environment.apiUrl + "api/getAllNotifications?organizationId=" + orgId, { headers: this.header1 });
  }

  getOrgRolesById(orgRoleId) {
    return this.http.get(environment.apiUrl + "api/getOrgRolesById/" + orgRoleId, { headers: this.header1 });
  }

  getNotificationsById(notificationId, orgId) {
    return this.http.get(environment.apiUrl + "api/notifications/" + notificationId + "?organizationId=" + orgId, { headers: this.header1 });
  }

  getWarehouseRequestsByApprovalStatus(orgId, status, accountType) {
    return this.http.get(environment.apiUrl + "api/warehouseRequestsByApprovalStatusAndOrgIdAndAccountOwnerId?approvalStatus=" + status + "&organizationId=" + orgId + "&accountType=" + accountType, { headers: this.header1 });
  }

  getAllSellersByStatus(status) {
    return this.http.get(environment.apiUrl + "api/getAllSellersByStatus?status=" + status, { headers: this.header1 });
  }

  getCustomerSellerById(sellerId) {
    return this.http.get(environment.apiUrl + "api/getCustomerSellerById/" + sellerId , { headers: this.header1 });
  }

  getAllSellerProductsByStatus(accountOwnerId, orgId, sellerId, status) {
    return this.http.get(environment.apiUrl + "api/getAllSellerProductsByStatus?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId + "&sellerId=" + sellerId + "&status=" + status, { headers: this.header1 });
  }

  getWarehouseAssignmentsById(id) {
    return this.http.get(environment.apiUrl + "api/getWarehouseAssignmentsById?id=" + id, { headers: this.header1 });
  }

  getOrganizationRoleList(orgId, status) {
    return this.http.get(environment.apiUrl + "api/getOrganizationRoleList?organizationId=" + orgId + "&status=" + status, { headers: this.header1 });
  }

  getAllConfiguredChannels(accountOwnerId, orgId) {
    return this.http.get(environment.apiUrl + "api/getAllConfiguredChannels/" + accountOwnerId + "?organizationId=" + orgId, { headers: this.header1 });
  }

  getApprovedWarehousesByAOId(accountOwnerId, orgId) {
    return this.http.get(environment.apiUrl + "api/getApprovedWarehousesByAOId?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId, { headers: this.header1 });
  }

  getAllWarehousesByAdmin(orgId, userRole, status) {
    return this.http.get(environment.apiUrl + "api/getAllWarehousesByAdmin/" + orgId + "/" + userRole + "/" + status, { headers: this.header1 });
  }

  getUserData() {
    return this.http.get(environment.apiUrl + "api/getRole", { headers: this.header1 });
  }

  getDistinctCities(orgId) {
    return this.http.get(environment.apiUrl + "api/distinctCities/" + orgId, { headers: this.header1 });
  }

  getWarehouses(orgId, city) {
    return this.http.get(environment.apiUrl + "api/warehouses/" + orgId + "/" + city, { headers: this.header1 });
  }

  getShippingPreferences() {
    return this.http.get(environment.apiUrl + "api/getShippingPreferences", { headers: this.header1 });
  }

  getWarehousesByOrgByStatus(orgId, status) {
    return this.http.get(environment.apiUrl + "api/getWarehousesByStatusAndOrgIdAndAOId?status=" + status + "&organizationId=" + orgId, { headers: this.header1 });
  }

  getWarehousesByOrgByStatusByAccountId(orgId, status, accountOwnerId) {
    return this.http.get(environment.apiUrl + "api/getWarehousesByStatusAndOrgIdAndAOId?accountOwnerId=" + accountOwnerId + "&status=" + status + "&organizationId=" + orgId, { headers: this.header1 });
  }

  getAssignedWarehouses(orgId, accountOwnerId, userRole) {
    return this.http.get(environment.apiUrl + "api/getAssignedWarehouses/" + orgId + "/" + userRole + "?accountOwnerId=" + accountOwnerId, { headers: this.header1 });
  }

  getAccountOwners(orgId, status) {
    return this.http.get(environment.apiUrl + "api/getActiveAccountOwners/" + orgId + "/" + status, { headers: this.header1 });
  }

  getBankAccountDetails() {
    return this.http.get(environment.apiUrl + "api/getBankAccountDetail", { headers: this.header1 });
  }

  getTrackingMenu(accountOwnerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getTrackingPageMenu?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  getTrackingMenuLiPublic(accountOwnerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/public/getTrackingPageMenu?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  getSellerTrackingMenu(sellerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getTrackingPageMenu?organizationId=" + organizationId + "&sellerId=" + sellerId, { headers: this.header1 });
  }

  getTrackingBanner(accountOwnerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getTrackingPageBanner?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  getTrackingBannerPublic(accountOwnerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/public/getTrackingPageBanner?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId, { headers: this.header1 });
  }
   getSellerTrackingBanner(organizationId,sellerId){
   return this.http.get(environment.apiUrl + "api/getTrackingPageBanner?organizationId=" + organizationId + "&sellerId=" + sellerId, {headers : this.header1});
  }

  getAccountOwnerData(accountId, accountType, status) {
    return this.http.get(environment.apiUrl + "api/getCODOrdersForUsers?accountId=" + accountId + "&accountType=" + accountType + "&status=" + status, { headers: this.header1 });
  }

  getAssignedWarehousesAdmin(orgId, userRole) {
    return this.http.get(environment.apiUrl + "api/getAssignedWarehouses/" + orgId + "/" + userRole, { headers: this.header1 });
  }

  getWarehousesByStatusAndOrgIdAndAOId(orgId, status, accountOwnerId) {
    return this.http.get(environment.apiUrl + "api/getWarehousesByStatusAndOrgIdAndAOId?accountOwnerId=" + accountOwnerId + "&status=" + status + "&organizationId=" + orgId, { headers: this.header1 });
  }

  getProductsByStatusAdmin(orgId, status) {
    return this.http.get(environment.apiUrl + "api/getProductsByStatusAndOrgIdAndAOId?organizationId=" + orgId + "&status=" + status, { headers: this.header1 });

  }

  /*  getProductsByStatusAdmin(accountOwnerId,orgId, status) {
        return this.http.get(environment.apiUrl + "api/getProductsByStatusAndOrgIdAndAOId?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId + "&status=" + status, {headers: this.header1});

      }  */

  getAllNotificationTypesList(orgId, status) {
    return this.http.get(environment.apiUrl + "api/getAllNotificationTypesList?organizationId=" + orgId + "&status=" + status, { headers: this.header1 });
  }

  getAllOpenApiTypes(orgId, status) {
    return this.http.get(environment.apiUrl + "api/getAllOpenApiTypes?organizationId=" + orgId + "&status=" + status, { headers: this.header1 });
  }

  getNotificationSettingsList() {
    return this.http.get(environment.apiUrl + "api/getNotificationSettingsList", { headers: this.header1 });
  }

  getApiSettingsList(apiUserId, accountOwnerId, orgId) {
    return this.http.get(environment.apiUrl + "api/getApiSettingsList/" + apiUserId + "/" + accountOwnerId + "/" + orgId, { headers: this.header1 });
  }

  getProductsByStatusAndOrgIdAndAOId(orgId, accountOwnerId, status) {
    return this.http.get(environment.apiUrl + "api/getProductsByStatusAndOrgIdAndAOId?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId + "&status=" + status, { headers: this.header1 });
  }

  getStockTransferHeadersList(accountOwnerId, orderStatus, orderType, orgId,) {
    return this.http.get(environment.apiUrl + "api/getStockTransferHeadersList?accountOwnerId=" + accountOwnerId + "&orderStatus=" + orderStatus + "&orderType= STOCK_TRANSFER" + "&organizationId=" + orgId, { headers: this.header1 });
  }

  getAdminStockTransferHeadersList(orderStatus, orderType, orgId,) {
    return this.http.get(environment.apiUrl + "api/getStockTransferHeadersList?orderStatus=" + orderStatus + "&orderType=STOCK_TRANSFER" + "&organizationId=" + orgId, { headers: this.header1 });
  }

  getProdWithBackOrdered(orgId, accountOwnerId, status) {
    return this.http.get(environment.apiUrl + "api/getProductsWithBackOrdered/" + accountOwnerId + "/" + orgId, { headers: this.header1 });
  }

  getProdWithLowStock(orgId, accountOwnerId, status) {
    return this.http.get(environment.apiUrl + "api/getProductsWithLowStock/" + accountOwnerId + "/" + orgId, { headers: this.header1 });
  }

  getProdWithOutOfStock(orgId, accountOwnerId, status) {
    return this.http.get(environment.apiUrl + "api/getProductsWithOutOfStock/" + accountOwnerId + "/" + orgId, { headers: this.header1 });
  }

  getAccountOwnerContacts(accountOwnerContactId, accountOwnerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/accountOwnerContacts/" + accountOwnerContactId + "?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  getProductsByAO(accountOwnerContactId) {
    return this.http.get(environment.apiUrl + "api/getProductsByAO/" + accountOwnerContactId, { headers: this.header1 });
  }

  getParentProducts(orgId, parentProductId) {
    return this.http.get(environment.apiUrl + "api/getKitCompByParentProductId?organizationId=" + orgId + "?parentProductId=" + parentProductId, { headers: this.header1 });
  }

  getAOContactsByStatusAndAOIdAndOrgId(orgId, accountOwnerId, status) {
    return this.http.get(environment.apiUrl + "api/getAOContactsByStatusAndAOIdAndOrgId?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId + "&status=" + status, { headers: this.header1 }).pipe(map((response: any) => response.contactResponseList));
  }

  getAOContactsByStatusByAdmin(orgId, status) {
    return this.http.get(environment.apiUrl + "api/getAOContactsByStatusAndAOIdAndOrgId?organizationId=" + orgId + "&status=" + status, { headers: this.header1 }).pipe(map((response: any) => response.contactResponseList));

  }

  getProductsByProductType(orgId, accountOwnerId, productType, status) {
    return this.http.get(environment.apiUrl + "api/getProductsByProductType?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId + "&productType=" + productType + "&status=" + status, { headers: this.header1 });
  }


  getKitCompByParentProductId(organizationId, parentProductId) {
    return this.http.get(environment.apiUrl + "api/getKitCompByParentProductId?organizationId=" + organizationId + "&parentProductId=" + parentProductId, { headers: this.header1 });
  }

  getProductsList(accountOwnerId?: any, orgId?: any) {
    let url = environment.apiUrl + "api/getProductList?"
      + (accountOwnerId !== undefined ? "accountOwnerId=" + accountOwnerId : "")
      + (orgId ? "&organizationId=" + orgId : "");

    return this.http.get(url, { headers: this.header1 });
  }

  getStockEntryHeaders(accountOwnerId, orgId, status) {
    return this.http.get(environment.apiUrl + "api/getStockEntryHeaders?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId + "&status=" + status, { headers: this.header1 });
  }

  getPackageInfoByOrderId(orderId, orderType) {
    return this.http.get(environment.apiUrl + "api/getPackageInfoByOrderId?orderId=" + orderId + "&orderType=" + orderType, { headers: this.header1 });
  }

  getCustNotificationSettingsById(id) {
    return this.http.get(environment.apiUrl + "api/getCustNotificationSettingsById/" + id , { headers: this.header1 });
  }

  getHeaderAndLinesById(headerId, accountOwnerId, orgId) {
    return this.http.get(environment.apiUrl + "api/getHeaderAndLinesById/" + headerId + "?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId, { headers: this.header1 });
  }

  getProductDetailsByProduct(organizationId, productId) {
    return this.http.get(environment.apiUrl + "api/getProductDetailsByProduct?organizationId=" + organizationId + "&productId=" + productId, { headers: this.header1 });
  }

  getKycAndMouDetailByAccountOwnerId(accountOwnerId, orgId) {
    return this.http.get(environment.apiUrl + "api/getKycAndMouDetailByAccountOwnerId/" + accountOwnerId + "/" + orgId, { headers: this.header1 });
  }

  getStockTransferDetailsId(headerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getStockTransferDetails/" + headerId + "?organizationId=" + organizationId, { headers: this.header1 });
  }

  getStockTransferDetailsIdPublic(headerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/public/getStockTransferDetails/" + headerId + "?organizationId=" + organizationId, {headers: this.header1});
  }

  getOrderTrackingDetails(orderId) {
    return this.http.get(environment.apiUrl + "api/getTrackingDetailsForOrder/?orderId=" + orderId, { headers: this.header1 });
  }

  getOrderTrackingDetailsPublic(orderId) {
    return this.http.get(environment.apiUrl + "api/public/getTrackingDetailsForOrder/?orderId=" + orderId, {headers: this.header1});
  }

  getStockTransferHeaderDetails(headerId) {
    return this.http.get(environment.apiUrl + "api/getStockTransferHeaderDetails/" + headerId, { headers: this.header1 });
  }

  getOrderInDetail(headerId) {
    return this.http.get(environment.apiUrl + "api/getOrderInDetail/" + headerId, { headers: this.header1 });
  }

  getWarehouseColumnList(accountOwnerId, orgId) {
    return this.http.get(environment.apiUrl + "api/getWarehouseColumnList?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId, { headers: this.header1 });
  }

  getGeneratedPickSlipWorkOrder(workOrderId) {
    return this.http.get(environment.apiUrl + "api/getGeneratedPickSlipWorkOrder?workOrderId=" + workOrderId, { headers: this.header1 });
  }

  getWHAssignmentList(accountOwnerId, orgId) {
    return this.http.get(environment.apiUrl + "api/getWHAssignmentList?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId, { headers: this.header1 });
  }

  getWarehouseColumnListAdmin(orgId) {
    return this.http.get(environment.apiUrl + "api/getWarehouseColumnList?organizationId=" + orgId, { headers: this.header1 });
  }

  getProductsByWarehouseProductStatus(accountOwnerId, warehouseId, orgId, productType) {
    return this.http.get(environment.apiUrl + "api/getProducts/" + accountOwnerId + "/" + warehouseId + "/" + orgId + "?productType=" + productType, { headers: this.header1 });
  }

  getProductsByWarehouse(accountOwnerId, warehouseId, orgId) {
    return this.http.get(environment.apiUrl + "api/getProducts/" + accountOwnerId + "/" + warehouseId + "/" + orgId, { headers: this.header1 });
  }

  getAvailableProdQty(accountOwnerId, organizationId, productId, warehouseId) {
    return this.http.get(environment.apiUrl + "api/getNewOrdersProductStockLevel?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId + "&productId=" + productId + "&warehouseId=" + warehouseId, { headers: this.header1 });
  }

  getWarehouseStock(accountOwnerId, warehouseId, orgId) {
    return this.http.get(environment.apiUrl + "api/getWarehouseStock?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId + "&warehouseId=" + warehouseId, { headers: this.header1 });
  }

  getOrdersByWarehouse(accountOwnerId, warehouseId, orgId) {
    return this.http.get(environment.apiUrl + "api/getOrdersByWarehouse/" + warehouseId + "/" + accountOwnerId + "?accountOwnerId=" + orgId, { headers: this.header1 });
  }

  getStockTransferList(ords, ordt, orgId) {
    return this.http.get(environment.apiUrl + "api/getStockTransferList?orderStatus=" + ords + "&orderType=" + ordt + "&organizationId=" + orgId, { headers: this.header1 });
  }

  getStockTransferReturnsList(ords, ordt, orgId) {
    return this.http.get(environment.apiUrl + "api/getStockTransferReturnsList?orderStatus=" + ords + "&orderType=" + ordt + "&organizationId=" + orgId, { headers: this.header1 });
  }

  getOrdersEligibleForReturns(accountOwnerId, orderNumber, organizationId) {
    return this.http.get(environment.apiUrl + "api/getOrdersEligibleForReturns?accountOwnerId=" + accountOwnerId + "&orderNumber=" + orderNumber + "&organizationId=" + organizationId, { headers: this.header1 });
  }


  getOrdersEligibleForReturns1(orderNumber){
      return this.http.get(environment.apiUrl + "api/orders/" + orderNumber + "/check-return-orders-eligibility", {headers: this.header1});
  }

  getOrdersEligibleForReturn(orderNumber){
        return this.http.get(environment.apiUrl + "api/orders/" + orderNumber + "/check-return-orders-eligibility", {headers: this.header1});
    }


  getShippingCarrier(orderNumber){
      return this.http.get(environment.apiUrl + "api/orders/" + orderNumber + "/return-pickup", {headers:this.header1});
  }

  getOrderStatus(accountOwnerId, ords, ordt, orgId) {
    return this.http.get(environment.apiUrl + "api/getStockTransferList?accountOwnerId=" + accountOwnerId + "&orderStatus=" + ords + "&orderType=" + ordt + "&organizationId=" + orgId, { headers: this.header1 });
  }

  getStockTransferAccountOwner(accountOwnerId, ords, ordt, orgId) {
    return this.http.get(environment.apiUrl + "api/getStockTransferReturnsList?accountOwnerId=" + accountOwnerId + "&orderStatus=" + ords + "&orderType=" + ordt + "&organizationId=" + orgId, { headers: this.header1 });
  }

  getStockTransferListAdmin(accountOwnerId, ords, ordt, orgId) {
    return this.http.get(environment.apiUrl + "api/getStockTransferList?accountOwnerId=" + accountOwnerId + "&orderStatus=" + ords + "&orderType=" + ordt + "&organizationId=" + orgId, { headers: this.header1 });
  }

  getShipmentsByAdmin(orderStatus, orgId) {
    return this.http.get(environment.apiUrl + "api/getAllShipmentData?organizationId=" + orgId + "&status=" + orderStatus, { headers: this.header1 });
  }

  getShipmentsByAccountOwner(accountOwnerId, orderStatus, orgId) {
    return this.http.get(environment.apiUrl + "api/getAllShipmentData?organizationId=" + orgId + "&status=" + orderStatus + "&accountOwnerId=" + accountOwnerId, { headers: this.header1 });
  }

  getOrderConsignmentsByStatusForAccountOwner(orderStatus, orderType) {
    return this.http.get(environment.apiUrl + "api/getOrderConsignmentsByStatus?orderStatus=" + orderStatus + "&orderType=" + orderType , { headers: this.header1 });
  }

  getAccountOwner(id) {
    return this.http.get(environment.apiUrl + "api/getAccountOwnerData?id=" + id , { headers: this.header1 });
  }

  getAdminDetail(id, organizationId) {
    return this.http.get(environment.apiUrl + "api/getAdminDetails?adminId=" + id + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  getBillingAddressById() {
    return this.http.get(environment.apiUrl + "api/getBillingAddressById" , { headers: this.header1 });
  }

  getReturnOrders(id, accountOwnerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getReturnOrders/" + id + "?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId, { headers: this.header1 });
  }


  getReturnOrders1(orderNumber) {
    return this.http.get(environment.apiUrl + "api/return-orders/" + orderNumber, {headers: this.header1});
 }

  getReturnOrder(orderNumber) {
    return this.http.get(environment.apiUrl + "api/return-orders/" + orderNumber, {headers: this.header1});
  }



  getInvoicesList(paymentStatus) {
    return this.http.get(environment.apiUrl + "api/getInvoicesList?paymentStatus=" + paymentStatus , { headers: this.header1 });
  }

  getInvoicesById(invoiceId) {
    return this.http.get(environment.apiUrl + "api/getInvoicesById/" + invoiceId , { headers: this.header1 });
  }

  trackShipmentByAWB(awcCode) {
    return this.http.get(environment.apiUrl + "api/trackShipmentByAWB?awb_code=" + awcCode, { headers: this.header1 });
  }

  getStockEntryHeadersAndLinesById(headerId, accountOwnerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getStockEntryHeadersAndLinesById/" + headerId + "?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  getPaymentStatus(orgId, status) {
    return this.http.get(environment.apiUrl + "api/getAllInvoicesByOrgIdAndPaymentStatus/" + orgId + "/" + status, { headers: this.header1 });
  }

  getAccOwnersByWarehouseId(headerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getAccOwnersByWarehouseId/" + headerId + "?organizationId=" + organizationId, { headers: this.header1 });
  }

  getProductListByProductId(headerId, accountOwnerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getProductListByProductId/" + headerId + "?accountOwnerId" + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  getWorkOrderList(accountOwnerId, orgId, status) {
    return this.http.get(environment.apiUrl + "api/getAllWrkOrderByAccOwnerAndStatus?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId + "&status=" + status, { headers: this.header1 });
  }

  getWorkOrderListAdmin(orgId, status) {
    return this.http.get(environment.apiUrl + "api/getAllWrkOrderByAccOwnerAndStatus?organizationId=" + orgId + "&status=" + status, { headers: this.header1 });
  }

  costEstimationForShiftAggregator(destPincode, originPincode, weight) {
    return this.http.get(environment.apiUrl + "api/costEstimationForShiftAggregator?destPincode=" + destPincode + "&originPincode=" + originPincode + "&weight=" + weight, { headers: this.header1 });
  }

  getConfigurationsList(accountOwnerId, orgId, storesManagementId) {
    return this.http.get(environment.apiUrl + "api/getConfigurationsList?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId + "&storesManagementId=" + storesManagementId, { headers: this.header1 });
  }

  getWorkOrderById(workOrderId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getWorkOrderById/" + workOrderId + "?organizationId=" + organizationId, { headers: this.header1 });
  }

  getupdateWorkOrderStatus(headerId) {
    return this.http.get(environment.apiUrl + "api/getupdateWorkOrderStatus/" + headerId, { headers: this.header1 });
  }

  getupdatePaymentStatus(headerId) {
    return this.http.get(environment.apiUrl + "api/getupdatePaymentStatus/" + headerId, { headers: this.header1 });
  }

  getUsersByAccOwnerId(status) {
    return this.http.get(environment.apiUrl + "api/getUsersByAccOwnerId/" + status, { headers: this.header1 });
  }

  getOwnerUserById(id) {
    return this.http.get(environment.apiUrl + "api/getOwnerUserById/" + id , { headers: this.header1 });
  }

  getShiftDrivers(id) {
    return this.http.get(environment.apiUrl + "api/getShiftDrivers/" + id, { headers: this.header1 });
  }

  getAddressList(status) {
    return this.http.get(environment.apiUrl + "api/getAddressList/" + status , { headers: this.header1 });
  }

  getAddressById(addressId, orgId) {
    return this.http.get(environment.apiUrl + "api/getAddressById?addressId=" + addressId + "&organizationId=" + orgId, { headers: this.header1 });
  }

  getShipmentHeadersAdmin(orgId, status) {
    return this.http.get(environment.apiUrl + "api/getShipmentHeadersAndLines?organizationId=" + orgId + "&status=" + status, { headers: this.header1 });
  }

  getShiftDriversList(orgId, status) {
    return this.http.get(environment.apiUrl + "api/getShiftDriversList?organizationId=" + orgId + "&status=" + status, { headers: this.header1 });
  }

  getShipmentHeaders(accountOwnerId, orgId, status) {
    return this.http.get(environment.apiUrl + "api/getShipmentHeadersAndLines?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId + "&status=" + status, { headers: this.header1 });
  }

  getUserAuthorities() {
    return this.http.get(environment.apiUrl + "api/users/authorities", { headers: this.header1 });
  }

  getChallanSettingsByAO(accountOwnerId, orgId) {
    return this.http.get(environment.apiUrl + "api/getChallanSttByAOId/" + accountOwnerId + "/" + orgId, { headers: this.header1 });
  }

  getShipmentList(accountOwnerId, orgId, status) {
    return this.http.get(environment.apiUrl + "api/getShipmentList?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId + "&status=" + status, { headers: this.header1 });
  }

  getShipmentLines(accountOwnerId, orgId, status) {
    return this.http.get(environment.apiUrl + "api/getShipmentLines?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId + "&status=" + status, { headers: this.header1 });
  }

  getAdminShipmentLines(orgId, status) {
    return this.http.get(environment.apiUrl + "api/getShipmentLines?organizationId=" + orgId + "&status=" + status, { headers: this.header1 });
  }

  getdriverShipmentLines(shiftDriverId, status) {
    return this.http.get(environment.apiUrl + "api/getShipmentLines/" + shiftDriverId + "/" + status, { headers: this.header1 });
  }

  getAllStoreManagementData(accountOwnerId, status, organizationId) {
    return this.http.get(environment.apiUrl + "api/getAllStoreManagementData/" + accountOwnerId + "/" + status + "?organizationId=" + organizationId, { headers: this.header1 });
  }

  getShipmentsLines(id) {
    return this.http.get(environment.apiUrl + "api/getShipmentsLines/" + id, { headers: this.header1 });
  }

  getPackingTypesList(orgId) {
    return this.http.get(environment.apiUrl + "api/getPackingTypesList?organizationId=" + orgId, { headers: this.header1 });
  }

  getPackingTypesListAccount(accountOwnerId, orgId) {
    return this.http.get(environment.apiUrl + "api/getPackingTypesList?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId, { headers: this.header1 });
  }

  getPackingTypesListSeller(sellerId, orgId) {
    return this.http.get(environment.apiUrl + "api/getPackingTypesList?sellerId=" + sellerId + "&organizationId=" + orgId, { headers: this.header1 });
  }

  getOrderCountByStatus(orgId) {
    return this.http.get(environment.apiUrl + "api/getOrderCountByStatus?organizationId=" + orgId, { headers: this.header1 });
  }

  getOrderCountByAccountStatus(accountOwnerId, orgId) {
    return this.http.get(environment.apiUrl + "api/getOrderCountByStatus?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId, { headers: this.header1 });
  }

  getAccountOwnerCountByStatus(orgId) {
    return this.http.get(environment.apiUrl + "api/getAccountOwnerCountByStatus?organizationId=" + orgId, { headers: this.header1 });
  }

  getInvoiceCountByStatus(orgId) {
    return this.http.get(environment.apiUrl + "api/getInvoiceCountByStatus?organizationId=" + orgId, { headers: this.header1 });
  }

  getWROCountByStatus(accountOwnerId, orgId) {
    return this.http.get(environment.apiUrl + "api/getWROCountByStatus?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId, { headers: this.header1 });
  }

  getWorkOrderCountByStatus(orgId) {
    return this.http.get(environment.apiUrl + "api/getWorkOrderCountByStatus?organizationId=" + orgId, { headers: this.header1 });
  }

  getStoreManagementById(storeMangeId, accountOwnerId, orgId) {
    return this.http.get(environment.apiUrl + "api/getStoreManagementById/" + storeMangeId + "?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId, { headers: this.header1 });
  }

  getTotalSpaceOfWarehouse(orgId) {
    return this.http.get(environment.apiUrl + "api/getTotalSpaceOfWarehouse?organizationId=" + orgId, { headers: this.header1 });
  }

  getProductsWithLowStock(accountOwnerId, orgId) {
    return this.http.get(environment.apiUrl + "api/getProductsWithLowStock/" + accountOwnerId + "/" + orgId, { headers: this.header1 });
  }

  getProductsWithOutOfStock(accountOwnerId, orgId) {
    return this.http.get(environment.apiUrl + "api/getProductsWithOutOfStock/" + accountOwnerId + "/" + orgId, { headers: this.header1 });
  }

  getByStoreId(accountOwnerId, orgId, storeId) {
    return this.http.get(environment.apiUrl + "api/getByStoreId?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId + "&storeId=" + storeId, { headers: this.header1 });
  }

  toGetMagentoProducts(accountOwnerId, organizationId, fromDate = '', storeId, toDate = '') {
    return this.http.get(environment.apiUrl + "api/toGetMagentoProducts/" + accountOwnerId + "?organizationId=" + organizationId + "&fromDate=" + fromDate + "&storeId=" + storeId + "&toDate=" + toDate, { headers: this.header1 });
  }

  toGetShopifyProducts(accountOwnerId, organizationId, fromDate = '', storeId, toDate = '') {
    return this.http.get(environment.apiUrl + "api/toGetAllShopifyProducts/" + accountOwnerId + "?organizationId=" + organizationId + "&fromDate=" + fromDate + "&storeId=" + storeId + "&toDate=" + toDate, { headers: this.header1 });
  }

  GetAllWooCommerceProducts(accountOwnerId, fromDate = '', storeId, organizationId, toDate = '') {
    return this.http.get(environment.apiUrl + "api/toGetWooCommerceProducts/" + accountOwnerId + "?fromDate=" + fromDate + "&storeId=" + storeId + "&organizationId=" + organizationId + "&toDate=" + toDate, { headers: this.header1 });
  }

  generateAmazonReport(query) {
    return this.http.get(environment.apiUrl + "api/generateAmazonReport", { params: query, headers: this.header1 });
  }

  toGetShopcluesProducts(accountOwnerId, fromDate = '', storeId, toDate = '') {
    return this.http.get(environment.apiUrl + "api/getAllProductsFromShopClues?accountOwnerId=" + accountOwnerId + "&fromDate=" + fromDate + "&storeId=" + storeId + "&toDate=" + toDate, { headers: this.header1 });
  }

  toGetBigCommerceProducts(accountOwnerId, fromDate = '', storeId, toDate = '') {
    return this.http.get(environment.apiUrl + "api/toGetBigCommerceProducts/" + accountOwnerId + "?fromDate=" + fromDate + "&storeId=" + storeId + "&toDate=" + toDate, { headers: this.header1 });
  }

  toGetWoocommerceProducts(accountOwnerId, fromDate = '', storeId, toDate = '') {
    return this.http.get(environment.apiUrl + "api/toGetAllWoocommerceProducts/" + accountOwnerId + "?fromDate=" + fromDate + "&storeId=" + storeId + "&toDate=" + toDate, { headers: this.header1 });
  }

  toGetFlipkartProducts(accountOwnerId, organizationId, storeId, skuIds = '') {
    return this.http.get(environment.apiUrl + "api/getProductsFromFlipkart/?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId + "&skuIds=" + skuIds + "&storeId=" + storeId, { headers: this.header1 });
  }

  toGetBigCommerceProductBySKU(accountOwnerId, sku, storeId) {
    return this.http.get(environment.apiUrl + "api/toGetBigCommerceProductBySKU/" + accountOwnerId + "?sku=" + sku + "&storeId=" + storeId, { headers: this.header1 });
  }

  getOpenCartProductsList(accountOwnerId, organizationId, storeId) {
    return this.http.get(environment.apiUrl + "api/getOpenCartProductsList/" + accountOwnerId + "?organizationId=" + organizationId + "&storeId=" + storeId, { headers: this.header1 });
  }

  getOpenCartOrdersList(accountOwnerId, fromDate, organizationId, status, storeId, toDate) {
    return this.http.get(environment.apiUrl + "api/getOpenCartOrdersList/" + accountOwnerId + "?fromDate=" + fromDate + "&organizationId=" + organizationId + "&status=" + status + "&storeId=" + storeId + "&toDate=" + toDate, { headers: this.header1 });
  }

  getOpenCartOrdersByOrderId(accountOwnerId, orderId, organizationId, storeId) {
    return this.http.get(environment.apiUrl + "api/getOpenCartOrdersByOrderId/" + accountOwnerId + "?orderId=" + orderId + "&organizationId=" + organizationId + "&storeId=" + storeId, { headers: this.header1 });
  }

  getOpenCartProductsById(accountOwnerId, organizationId, productId, storeId) {
    return this.http.get(environment.apiUrl + "api/getOpenCartProductsById/" + accountOwnerId + "?organizationId=" + organizationId + "&productId=" + productId + "&storeId=" + storeId, { headers: this.header1 });
  }

  getWarehousesByAccountOwner(accountOwnerId) {
    return this.http.get(environment.apiUrl + "api/getWarehousesByAccountOwner/" + accountOwnerId + "?organizationId=1", { headers: this.header1 });
  }

  getAmazonSlots(orderHeaderId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getAmazonSlots?orderHeaderId=" + orderHeaderId + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  getAllMagentoOrders(accountOwnerId, organizationId, fromDate = '', storeId, toDate = '', status = '') {
    return this.http.get(environment.apiUrl + "api/getAllMagentoOrders/" + accountOwnerId + "?organizationId=" + organizationId + "&fromDate=" + fromDate + "&storeId=" + storeId + "&toDate=" + toDate + "&status=" + status, { headers: this.header1 });
  }

  getAllShopifyOrders(accountOwnerId, fromDate = '', storeId, toDate = '', organizationId, orderStatus = '', fulfillmentStatus = '') {
    return this.http.get(environment.apiUrl + "api/toGetShopifyOrders/" + accountOwnerId + "?fromDate=" + fromDate + "&storeId=" + storeId + "&toDate=" + toDate + "&organizationId=" + organizationId + "&orderStatus=" + orderStatus + (fulfillmentStatus !== '' ? ("&fulfillmentStatus=" + fulfillmentStatus) : ''), { headers: this.header1 });
  }

  toGetALLWooCommerceOrders(accountOwnerId, fromDate = '', storeId, toDate = '', orderStatus = '', organizationId) {
    return this.http.get(environment.apiUrl + "api/toGetWooCommerceOrders/" + accountOwnerId + "?fromDate=" + fromDate + "&storeId=" + storeId + "&toDate=" + toDate + "&orderStatus=" + orderStatus + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  toGetSnapdealOrders(accountOwnerId, fromDate = '', storeId, toDate = '', orderStatus = '', organizationId) {
    return this.http.get(environment.apiUrl + "api/toGetSnapdealOrders/" + accountOwnerId + "?fromDate=" + fromDate + "&storeId=" + storeId + "&toDate=" + toDate + "&orderStatus=" + orderStatus + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  getAllShopcluesOrders(accountOwnerId, fromDate = '', storeId, toDate = '', status = '') {
    return this.http.get(environment.apiUrl + "api/toGetShopCluesOrders/" + accountOwnerId + "?fromDate=" + fromDate + "&storeId=" + storeId + "&toDate=" + toDate + "&status=" + status, { headers: this.header1 });
  }

  getAllOrdersFromShopClues(accountOwnerId, fromDate = '', organizationId, storeId, orderStatus = '', toDate = '') {
    return this.http.get(environment.apiUrl + "api/getAllOrdersFromShopClues?accountOwnerId=" + accountOwnerId + "&fromDate=" + fromDate + "&organizationId=" + organizationId + "&storeId=" + storeId + "&orderStatus=" + orderStatus + "&toDate=" + toDate, { headers: this.header1 });
  }

  getAllWoocommerceOrders(accountOwnerId, fromDate = '', storeId, toDate = '', organizationId) {
    return this.http.get(environment.apiUrl + "api/toGetWoocommerceOrders/" + accountOwnerId + "?fromDate=" + fromDate + "&storeId=" + storeId + "&toDate=" + toDate + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  getAllFlipkartOrders(accountOwnerId, fromDate = '', storeId, toDate = '') {
    return this.http.get(environment.apiUrl + "api/toGetFlipkartOrders/" + accountOwnerId + "?fromDate=" + fromDate + "&storeId=" + storeId + "&toDate=" + toDate, { headers: this.header1 });
  }

  getAllEbayOrders(accountOwnerId, fromDate = '', storeId, toDate = '') {
    return this.http.get(environment.apiUrl + "api/toGetEbayOrders/" + accountOwnerId + "?fromDate=" + fromDate + "&storeId=" + storeId + "&toDate=" + toDate, { headers: this.header1 });
  }

  getAllMagentoOrderByOrderNumber(accountOwnerId, sourceOrderNumber, organizationId, storeId) {
    return this.http.get(environment.apiUrl + "api/getAllMagentoOrderByOrderNumber/" + accountOwnerId + "/" + sourceOrderNumber + "?organizationId=" + organizationId + "&storeId=" + storeId, { headers: this.header1 });
  }

  GetMagentoProductBySku(accountOwnerId, organizationId, skuNumber, storeId) {
    return this.http.get(environment.apiUrl + "api/toGetMagentoProductBySku/" + accountOwnerId + "?organizationId=" + organizationId + "&sku=" + skuNumber + "&storeId=" + storeId, { headers: this.header1 });
  }

  GetWoocommerceProductBySKU(accountOwnerId, organizationId, skuNumber, storeId) {
    return this.http.get(environment.apiUrl + "api/toGetWoocommerceProductBySKU/" + accountOwnerId + "?organizationId=" + organizationId + "&sku=" + skuNumber + "&storeId=" + storeId, { headers: this.header1 });
  }

  toGetSnapdealProductBySKU(accountOwnerId, organizationId, skuNumber, storeId) {
    return this.http.get(environment.apiUrl + "api/toGetSnapdealProductBySKU/" + accountOwnerId + "?organizationId=" + organizationId + "&sku=" + skuNumber + "&storeId=" + storeId, { headers: this.header1 });
  }

  getAllShopifyOrderByOrderNumber(accountOwnerId, organizationId, sourceOrderNumber, storeId, status = '') {
    return this.http.get(environment.apiUrl + "api/getShopifyOrderByOrderNumber/" + accountOwnerId + "/" + sourceOrderNumber + "?organizationId=" + organizationId + "&storeId=" + storeId + "&status=" + status, { headers: this.header1 });
  }

  getAllShopcluesOrderByOrderNumber(accountOwnerId, sourceOrderNumber, storeId, status = '') {
    return this.http.get(environment.apiUrl + "api/getShopCluesOrderByOrderNumber/" + accountOwnerId + "/" + sourceOrderNumber + "?storeId=" + storeId + "&status=" + status, { headers: this.header1 });
  }

  getAllWoocommerceOrderByOrderNumber(accountOwnerId, sourceOrderNumber, organizationId, storeId) {
    return this.http.get(environment.apiUrl + "api/getWoocommerceOrderByOrderNumber/" + accountOwnerId + "/" + sourceOrderNumber + "?organizationId=" + organizationId + "&storeId=" + storeId, { headers: this.header1 });
  }

  getWooCommerceOrderByOrderNumber(accountOwnerId, sourceOrderNumber, organizationId, storeId) {
    return this.http.get(environment.apiUrl + "api/getWooCommerceOrderByOrderNumber/" + accountOwnerId + "/" + sourceOrderNumber + "?organizationId=" + organizationId + "&storeId=" + storeId, { headers: this.header1 });
  }

  getSnapdealOrderByOrderNumber(accountOwnerId, sourceOrderNumber, organizationId, storeId) {
    return this.http.get(environment.apiUrl + "api/getSnapdealOrderByOrderNumber/" + accountOwnerId + "/" + sourceOrderNumber + "?organizationId=" + organizationId + "&storeId=" + storeId, { headers: this.header1 });
  }

  getAllFlipkartOrderByOrderNumber(accountOwnerId, sourceOrderNumber, storeId) {
    return this.http.get(environment.apiUrl + "api/getFlipkartOrderByOrderNumber/" + accountOwnerId + "/" + sourceOrderNumber + "?storeId=" + storeId, { headers: this.header1 });
  }

  getAllEbayOrderByOrderNumber(accountOwnerId, sourceOrderNumber, storeId) {
    return this.http.get(environment.apiUrl + "api/getEbayOrderByOrderNumber/" + accountOwnerId + "/" + sourceOrderNumber + "?storeId=" + storeId, { headers: this.header1 });
  }

  getProductsFromEbay(accountOwnerId, fromDate = '', toDate = '') {
    return this.http.get(environment.apiUrl + "api/getProductsFromEbay/" + accountOwnerId + "?fromDate=" + fromDate + "&toDate=" + toDate, { headers: this.header1 });
  }

  getOrdersFromFlipkart(accountOwnerId, fromDate = '', toDate = '') {
    return this.http.get(environment.apiUrl + "api/getOrdersFromFlipkart/" + accountOwnerId + "?fromDate=" + fromDate + "&toDate=" + toDate, { headers: this.header1 });
  }

  getOrdersFromEbay(accountOwnerId, fromDate = '', toDate = '') {
    return this.http.get(environment.apiUrl + "api/getOrdersFromEbay/" + accountOwnerId + "?fromDate=" + fromDate + "&toDate=" + toDate, { headers: this.header1 });
  }

  toGetAllShopifyProducts(accountOwnerId, organizationId, fromDate = '', toDate = '') {
    return this.http.get(environment.apiUrl + "api/toGetAllShopifyProducts/" + accountOwnerId + "?organizationId=" + organizationId + "&fromDate=" + fromDate + "&toDate=" + toDate, { headers: this.header1 });
  }

  toGetAllShopcluesProducts(accountOwnerId, fromDate = '', toDate = '') {
    return this.http.get(environment.apiUrl + "api/getAllProductsFromShopClues/" + accountOwnerId + "?fromDate=" + fromDate + "&toDate=" + toDate, { headers: this.header1 });
  }

  toGetAllWoocommerceProducts(accountOwnerId, fromDate = '', toDate = '') {
    return this.http.get(environment.apiUrl + "api/toGetAllWoocommerceProducts/" + accountOwnerId + "?fromDate=" + fromDate + "&toDate=" + toDate, { headers: this.header1 });
  }

  toGetAllFlipkartProducts(accountOwnerId, fromDate = '', toDate = '') {
    return this.http.get(environment.apiUrl + "api/toGetAllFlipkartProducts/" + accountOwnerId + "?fromDate=" + fromDate + "&toDate=" + toDate, { headers: this.header1 });
  }

  toGetAllEbayProducts(accountOwnerId, fromDate = '', toDate = '') {
    return this.http.get(environment.apiUrl + "api/toGetAllEbayProducts/" + accountOwnerId + "?fromDate=" + fromDate + "&toDate=" + toDate, { headers: this.header1 });
  }

  toGetShopifyOrders(accountOwnerId, fromDate = '', toDate = '', organizationId) {
    return this.http.get(environment.apiUrl + "api/toGetShopifyOrders/" + accountOwnerId + "?fromDate=" + fromDate + "&toDate=" + toDate + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  toGetShopcluesOrders(accountOwnerId, fromDate = '', toDate = '') {
    return this.http.get(environment.apiUrl + "api/toGetShopcluesOrders/" + accountOwnerId + "?fromDate=" + fromDate + "&toDate=" + toDate, { headers: this.header1 });
  }

  toGetWoocommerceOrders(accountOwnerId, fromDate = '', toDate = '', status, organizationId) {
    return this.http.get(environment.apiUrl + "api/toGetWoocommerceOrders/" + accountOwnerId + "?fromDate=" + fromDate + "&toDate=" + toDate + "&status=" + status + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  toGetEbayOrders(accountOwnerId, fromDate = '', toDate = '') {
    return this.http.get(environment.apiUrl + "api/toGetEbayOrders/" + accountOwnerId + "?fromDate=" + fromDate + "&toDate=" + toDate, { headers: this.header1 });
  }

  getPrductsFromShopclues(accountOwnerId, fromDate = '', toDate = '') {
    return this.http.get(environment.apiUrl + "api/getPrductsFromShopclues/" + accountOwnerId + "?fromDate=" + fromDate + "&toDate=" + toDate, { headers: this.header1 });
  }

  getOrdersFromShopclues(accountOwnerId, fromDate = '', toDate = '') {
    return this.http.get(environment.apiUrl + "api/getOrdersFromShopclues/" + accountOwnerId + "?fromDate=" + fromDate + "&toDate=" + toDate, { headers: this.header1 });
  }

  toGetWooCommerceProducts(accountOwnerId, fromDate = '', organizationId, toDate = '') {
    return this.http.get(environment.apiUrl + "api/toGetWooCommerceProducts/" + accountOwnerId + "?fromDate=" + fromDate + "&organizationId=" + organizationId + "&toDate=" + toDate, { headers: this.header1 });
  }

  toGetWooCommerceOrders(accountOwnerId, fromDate = '', toDate = '', organizationId) {
    return this.http.get(environment.apiUrl + "api/toGetWooCommerceOrders/" + accountOwnerId + "?fromDate=" + fromDate + "&toDate=" + toDate + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  toGetFlipkartOrders(accountOwnerId, fromDate = '', toDate = '') {
    return this.http.get(environment.apiUrl + "api/toGetFlipkartOrders/" + accountOwnerId + "?fromDate=" + fromDate + "&toDate=" + toDate, { headers: this.header1 });
  }

  getAccessKey(accountOwnerId) {
    return this.http.get(environment.apiUrl + "api/getAccessKeyByAccountOwnerId/" + accountOwnerId, { headers: this.header1 });
  }

  toSyncNowStoreOrders(accountOwnerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/toSyncNowStoreOrders/" + accountOwnerId + "?organizationId=" + organizationId, { headers: this.header1 });
  }

  getAllSecurityType(organizationId) {
    return this.http.get(environment.apiUrl + "api/getAllSecurityType/" + organizationId, { headers: this.header1 });
  }

  getFulfillmentPrices() {
    return this.http.get(environment.apiUrl + "api/getFulfillmentPrices", { headers: this.header1 });
  }

  getAdditionalPrices(organizationId, service) {
    return this.http.get(environment.apiUrl + "api/getAdditionalPrices?organizationId=" + organizationId + "&service=" + service, { headers: this.header1 });
  }

  customerGetAdditionalPrices(accountOwnerId, organizationId, service) {
    return this.http.get(environment.apiUrl + "api/getAdditionalPrices?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId + "&service=" + service, { headers: this.header1 });
  }

  getAllActiveSecurityType(organizationId) {
    return this.http.get(environment.apiUrl + "api/getAllActiveSecurityType/" + organizationId, { headers: this.header1 });
  }

  getGroup(groupName, organizationId) {
    return this.http.get(environment.apiUrl + "api/getSecurityTypeByName/" + groupName + "/" + organizationId, { headers: this.header1 });
  }

  getAllApplicationSecurityTypes(groupName) {
    return this.http.get(environment.apiUrl + "api/getAllApplicationSecurityTypes/" + groupName, { headers: this.header1 });
  }

  getAllSecurityConfigByUserId(jhiUserId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getAllSecurityConfigByUserId/" + jhiUserId + "?organizationId=" + organizationId, { headers: this.header1 });
  }

  activateKey(key) {
    return this.http.get(environment.apiUrl + "api/activate?key=" + key, { headers: this.header1 });
  }

  getAllCustomerInfosByEmailAndCode(email, code, organizationId) {
    return this.http.get(environment.apiUrl + "api/getAllCustomerInfosByEmailAndCode/" + email + "/" + code + "/" + organizationId, { headers: this.header1 });
  }

  getReturnOrderByAOSeller(accountOwnerId, orderStatus, organizationId, sellerId) {
    return this.http.get(environment.apiUrl + "api/getReturnOrderByAOSeller?accountOwnerId=" + accountOwnerId + "&orderStatus=" + orderStatus + "&organizationId=" + organizationId + "&sellerId=" + sellerId, { headers: this.header1 }).pipe(map((response: any) => response.usersData));
  }

  getAllAdminUsers(organizationId, status) {
    return this.http.get(environment.apiUrl + "api/getAllAdminUsers/" + organizationId + "/" + status, { headers: this.header1 }).pipe(map((response: any) => response.usersData));
  }

  getAllAdminUsersByRole(organizationId, status, query) {
    return this.http.get(environment.apiUrl + "api/getAllAdminUsersByRole/" + organizationId + "/" + status, {
      params: query,
      headers: this.header1
    });
  }

  getAllAssignedPackOrders(organizationId, query) {
    return this.http.get(environment.apiUrl + "api/getAllAssignedOrders?organizationId=" + organizationId, {
      params: query,
      headers: this.header1
    });
  }

  getAllAssignedOrders(orgUserId, organizationId, status) {
    return this.http.get(environment.apiUrl + "api/getAllAssignedOrders?orgUserId=" + orgUserId + "&organizationId=" + organizationId + "&status=" + status, { headers: this.header1 });
  }

  getAllAssignedWorkOrders(orgUserId, status, organizationId) {
    return this.http.get(environment.apiUrl + "api/getAllAssignedWorkOrders/" + orgUserId + "/" + status + "?organizationId=" + organizationId, { headers: this.header1 });
  }

  getAllAssignedStockTransfers(orgUserId, status) {
    return this.http.get(environment.apiUrl + "api/getAllAssignedStockTransfers/" + orgUserId + "/" + status, { headers: this.header1 });
  }

  getTotesList(organizationId) {
    return this.http.get(environment.apiUrl + "api/getTotesList/" + organizationId, { headers: this.header1 });
  }

  getGeneratedPickSlip(orderHeaderId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getGeneratedPickSlip?orderHeaderId=" + orderHeaderId + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  getGeneratedPickSlipForStockTransferHeader(organizationId, stockTransferHeaderId) {
    return this.http.get(environment.apiUrl + "api/getGeneratedPickSlipForStockTransferHeader?organizationId=" + organizationId + "&stockTransferHeaderId=" + stockTransferHeaderId, { headers: this.header1 });
  }

  generateShippingLabelForStockTransfer(headerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/generateShippingLabelForStockTransfer/" + headerId + "?organizationId=" + organizationId, { headers: this.header1 });
  }

  generateShippingLabelForOrders(headerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/generateShippingLabelForOrders/" + headerId + "?organizationId=" + organizationId, { headers: this.header1 });
  }

  getOrderActivities(headerId, status, organizationId) {
    return this.http.get(environment.apiUrl + "api/getOrderActivities/" + headerId + "/" + status + "?organizationId=" + organizationId, { headers: this.header1 });
  }

  changePassword(request) {
    return this.http.post(environment.apiUrl + "api/account/change-password", request, { headers: this.header1 });
  }

  saveStoreCredentials(request1) {
    return this.http.post(environment.apiUrl + "api/saveStoreCredentials", request1, { headers: this.header1 });
  }

  generateShippingLabelForStockEntry(headerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/generateShippingLabelForStockEntry/" + headerId + "?organizationId=" + organizationId, { headers: this.header1 });
  }

  getWarehouseRequestByRequestId(organizationId, requestId) {
    return this.http.get(environment.apiUrl + "api/getWarehouseRequestByRequestId?organizationId=" + organizationId + "&requestId=" + requestId, { headers: this.header1 });
  }

  getStoreCredentials(sellerId) {
    return this.http.get(environment.apiUrl + "api/getStoreCredentials?sellerId=" + sellerId, { headers: this.header1 });
  }

  /*  getOrderReports(accountOwnerId, fromDate='', organizationId, sourceType, toDate='') {
    return this.http.get(environment.apiUrl + "api/getOrderReports?accountOwnerId=" + accountOwnerId + "&fromDate=" +fromDate + "&organizationId=" + organizationId + "&sourceType=" + sourceType + "&toDate=" + toDate, {headers: this.header1});
    }
        getDemandBySKUReports(accountOwnerId, fromDate='', organizationId, status, sourceType, toDate='') {
    return this.http.get(environment.apiUrl + "api/getDemandBySKUReports?accountOwnerId=" + accountOwnerId + "&fromDate=" +fromDate + "&organizationId=" + organizationId + "&status=" + status + "&sourceType=" + sourceType + "&toDate=" + toDate, {headers: this.header1});
    }

     getInventoryReports(accountOwnerId, orgId) {
      return this.http.get(environment.apiUrl + "api/getInventoryReports?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId, {headers: this.header1});
    } */
  getReports(apiMethod, query) {
    return this.http.get(environment.apiUrl + 'api/' + apiMethod, { params: query, headers: this.header1 });
  }

  getOrdersCount() {
    return this.http.get(environment.apiUrl + "api/getOrdersCount", {headers: this.header1 });
  }

  getNDRReport() {
    return this.http.get(environment.apiUrl + "api/getNDRReport", { headers: this.header1 });
  }

  getSellerOrdersCount(query) {
    return this.http.get(environment.apiUrl + "api/getSellerOrdersCount", { params: query, headers: this.header1 });
  }

  getProductsCount(query) {
    return this.http.get(environment.apiUrl + "api/getProductsCount", { params: query, headers: this.header1 });
  }

  getInvoiceDetails(query) {
    return this.http.get(environment.apiUrl + "api/getInvoiceDetails", { params: query, headers: this.header1 });
  }

  getCustomerAccountingSummary() {
    return this.http.get(environment.apiUrl + "api/getCustomerAccountingSummary", { headers: this.header1 });
  }

  getShipmentsCount() {
    return this.http.get(environment.apiUrl + "api/getShipmentsCount", { headers: this.header1 });
  }

  getWROCountOnDate(query) {
    return this.http.get(environment.apiUrl + "api/getWROCountOnDate", { params: query, headers: this.header1 });
  }

  getOrdersCountPastAMonth(apiMethod, query) {
    return this.http.get(environment.apiUrl + "api/" + apiMethod, { params: query, headers: this.header1 });
  }

  getTenProductsWithLowStock(accountOwnerId, orgId) {
    return this.http.get(environment.apiUrl + "api/getTenProductsWithLowStock/" + accountOwnerId + "/" + orgId, { headers: this.header1 });
  }

  getTenProductsOutOfStock(accountOwnerId, orgId, query) {
    return this.http.get(environment.apiUrl + "api/getTenProductsOutOfStock/" + accountOwnerId + "/" + orgId, {
      params: query,
      headers: this.header1
    });
  }

  getTenCustomersWithMaxLowStock(orgId) {
    return this.http.get(environment.apiUrl + "api/getTenCustomersWithMaxLowStock/" + orgId + "?status=ALL", { headers: this.header1 });
  }

  getTenCustomersMaxOutOfStock(orgId) {
    return this.http.get(environment.apiUrl + "api/getTenCustomersMaxOutOfStock/" + orgId + "?status=ALL", { headers: this.header1 });
  }

  getTopFiveCustomersNamesBasedOnOrdersCount(orgId) {
    return this.http.get(environment.apiUrl + "api/getTopFiveCustomersNamesBasedOnOrdersCount?organizationId=" + orgId, { headers: this.header1 });
  }

  getTopFiveCustomersNamesBasedOnMaxRevenue(orgId) {
    return this.http.get(environment.apiUrl + "api/getTopFiveCustomersNamesBasedOnMaxRevenue?organizationId=" + orgId, { headers: this.header1 });
  }

  getReturnOrderList(accountOwnerId, orderStatus, orgId) {
    return this.http.get(environment.apiUrl + "api/getReturnOrderList?accountOwnerId=" + accountOwnerId + "&orderStatus=" + orderStatus + "&organizationId=" + orgId, { headers: this.header1 });
  }

  adminGetReturnOrderList(orderStatus, orgId) {
    return this.http.get(environment.apiUrl + "api/getReturnOrderList?orderStatus=" + orderStatus + "&organizationId=" + orgId, { headers: this.header1 });
  }

  getOrdersCountForOnHold(query) {
    return this.http.get(environment.apiUrl + "api/getOrdersCountForOnHold", { params: query, headers: this.header1 });
  }

  getNewOrdersProductStockLevel(accountOwnerId, organizationId, warehouseId, productId) {
    return this.http.get(environment.apiUrl + "api/getNewOrdersProductStockLevel?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId + "&productId=" + productId + "&warehouseId=" + warehouseId, { headers: this.header1 });
  }

  configureMagentoCategories(accountOwnerId, organizationId, storeId) {
    return this.http.get(environment.apiUrl + "api/configureMagentoCategories?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId + "&storeId=" + storeId, { headers: this.header1 });
  }

  getReturnableProductList(accountOwnerId, orgId, isReturnable) {
    return this.http.get(environment.apiUrl + "api/getReturnableProductList?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId + "&isReturnable=" + isReturnable, { headers: this.header1 });
  }

  getReturnableProductListBySellerId(accountOwnerId, orgId, isReturnable, sellerId) {
    return this.http.get(environment.apiUrl + "api/getReturnableProductList?accountOwnerId=" + accountOwnerId + "&organizationId=" + orgId + "&isReturnable=" + isReturnable + "&sellerId=" + sellerId, { headers: this.header1 });
  }

  getAllCustomersListAndSellerList() {
    return this.http.get(environment.apiUrl + "api/getAllCustomersListAndSellerList", { headers: this.header1 });
  }


  generateInvoiceFromChannels(orgId) {
    return this.http.get(environment.apiUrl + "api/generateInvoiceFromChannels/" + orgId, { headers: this.header1 });
  }

  downloadCustInvoice(accountOwnerId, orderHeaderId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getEndCustomerInvoices?accountOwnerId=" + accountOwnerId + "&orderHeaderId=" + orderHeaderId + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  getContactsByCustomerType(orgId: any, accountOwnerId?: any, status?: string, customerType?: string) {
    let url = environment.apiUrl + "api/getContactsByCustomerType?"
      + "organizationId=" + orgId
      + (accountOwnerId ? "&accountOwnerId=" + accountOwnerId : "")
      + (status ? "&status=" + status : "")
      + (customerType ? "&customerType=" + customerType : "");

    return this.http.get(url, { headers: this.header1 });
  }

  getOrdersDetailsByProductId(orgId, productId) {
    return this.http.get(environment.apiUrl + "api/getOrdersDetailsByProductId?organizationId=" + orgId + "&productId=" + productId, { headers: this.header1 });
  }

  getInvoicePreference() {
    return this.http.get(environment.apiUrl + "api/getInvoicePreference", {
      responseType: 'text',
      headers: this.header1
    });
  }

  toSyncNowAllSellerOrders(accountOwnerId, orgId) {
    return this.http.get(environment.apiUrl + "api/toSyncNowAllSellerOrders/" + accountOwnerId + "?organizationId=" + orgId, {
      responseType: 'text',
      headers: this.header1
    });
  }

  updateInvoicePreference(organizationId, accountOwnerId, preferenceType) {
    return this.http.post(environment.apiUrl + "api/updateInvoicePreference", {
      organizationId,
      accountOwnerId,
      preferenceType
    }, { headers: this.header1 });
  }

  updateItemValue(body) {
    return this.http.post(environment.apiUrl + "api/createTripleSetConfigs", body, { headers: this.header1 });
  }

  getAllAmazonOrderByOrderNumber(accountOwnerId, sourceOrderNumber, organizationId, storeId) {
    return this.http.get(environment.apiUrl + "api/getAllAmazonOrderByOrderNumber/" + accountOwnerId + "/" + sourceOrderNumber + "?organizationId=" + organizationId + "&storeId=" + storeId, { headers: this.header1 });
  }

  toGetBigCommerceOrders(accountOwnerId, fromDate = '', storeId, status, toDate = '', organizationId) {
    return this.http.get(environment.apiUrl + "api/toGetBigCommerceOrders/" + accountOwnerId + "?fromDate=" + fromDate + "&storeId=" + storeId + "&status=" + status + "&toDate=" + toDate + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  getAllBigcommerceOrderByOrderNumber(accountOwnerId, sourceOrderNumber, organizationId, storeId) {
    return this.http.get(environment.apiUrl + "api/getAllBigcommerceOrderByOrderNumber/" + accountOwnerId + "/" + sourceOrderNumber + "?organizationId=" + organizationId + "&storeId=" + storeId, { headers: this.header1 });
  }

  adminGetAllShipmentData(orgId, status) {
    return this.http.get(environment.apiUrl + "api/getAllShipmentData?organizationId=" + orgId + "&status=" + status, { headers: this.header1 });
  }

  getAllCustomersList(status) {
    return this.http.get(environment.apiUrl + "api/getAllCustomersList/"  + status, { headers: this.header1 });
  }

  trackOrderForShiftAggregator(carrierCode, orderId, orderType, waybill) {
    return this.http.get(environment.apiUrl + "api/trackOrderForShiftAggregator?carrierCode=" + carrierCode + "&orderId=" + orderId + "&orderType=" + orderType + "&waybill=" + waybill, { headers: this.header1 });
  }

  getZohoCommerceProductById(accountOwnerId, organizationId, productId, storeId) {
    return this.http.get(environment.apiUrl + "api/getZohoCommerceProductById?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId + "&productId=" + productId + "&storeId=" + storeId, { headers: this.header1 });
  }

  getStoreHippoProductBySKU(accountOwnerId, organizationId, storeSku, storeId) {
    return this.http.get(environment.apiUrl + "api/getStoreHippoProductBySKU?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId + "&storeSku=" + storeSku + "&storeId=" + storeId, { headers: this.header1 });
  }


  getPrestaShopProductsById(accountOwnerId, organizationId, productId, storeId) {
    return this.http.get(environment.apiUrl + "api/getPrestaShopProductsById/" + accountOwnerId + "?organizationId=" + organizationId + "&productId=" + productId + "&storeId=" + storeId, { headers: this.header1 });
  }

  getZohoCommerceProductsList(accountOwnerId, organizationId, storeId) {
    return this.http.get(environment.apiUrl + "api/getZohoCommerceProductsList?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId + "&storeId=" + storeId, { headers: this.header1 });
  }

  getPrestaShopProducts(accountOwnerId, organizationId, storeId) {
    return this.http.get(environment.apiUrl + "api/getPrestaShopProducts/" + accountOwnerId + "?organizationId=" + organizationId + "&storeId=" + storeId, { headers: this.header1 });
  }

  getStoreHippoProducts(accountOwnerId, organizationId, storeId) {
    return this.http.get(environment.apiUrl + "api/getStoreHippoProducts?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId + "&storeId=" + storeId, { headers: this.header1 });
  }

  getZohoCommerceOrderById(accountOwnerId, orderNumber, organizationId, storeId) {
    return this.http.get(environment.apiUrl + "api/getZohoCommerceOrderById?accountOwnerId=" + accountOwnerId + "&orderNumber=" + orderNumber + "&organizationId=" + organizationId + "&storeId=" + storeId, { headers: this.header1 });
  }

  getZohoCommerceOrders(accountOwnerId, orderStatus, organizationId, storeId) {
    return this.http.get(environment.apiUrl + "api/getZohoCommerceOrders?accountOwnerId=" + accountOwnerId + "&orderStatus=" + orderStatus + "&organizationId=" + organizationId + "&storeId=" + storeId, { headers: this.header1 });
  }

  getPrestaShopOrders(accountOwnerId, organizationId, fromDate = '', toDate = '', storeId) {
    return this.http.get(environment.apiUrl + "api/getPrestaShopOrders/" + accountOwnerId + "?organizationId=" + organizationId + "&fromDate=" + fromDate + "&toDate=" + toDate + "&storeId=" + storeId, { headers: this.header1 });
  }

  getStoreHippoOrdersByDate(accountOwnerId, organizationId, fromDate = '', toDate = '', storeId) {
    return this.http.get(environment.apiUrl + "api/getStoreHippoOrdersByDate?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId + "&fromDate=" + fromDate + "&toDate=" + toDate + "&storeId=" + storeId, { headers: this.header1 });
  }

  getPrestaShopOrderById(accountOwnerId, orderNumber, organizationId, storeId) {
    return this.http.get(environment.apiUrl + "api/getPrestaShopOrderById/" + accountOwnerId + "?orderId=" + orderNumber + "&organizationId=" + organizationId + "&storeId=" + storeId, { headers: this.header1 });
  }

  getStoreHippoOrderById(accountOwnerId, orderNumber, organizationId, storeId) {
    return this.http.get(environment.apiUrl + "api/getStoreHippoOrderById?accountOwnerId=" + accountOwnerId + "&orderId=" + orderNumber + "&organizationId=" + organizationId + "&storeId=" + storeId, { headers: this.header1 });
  }

  getStoreHippoOrdersByStatus(accountOwnerId, organizationId, status, storeId) {
    return this.http.get(environment.apiUrl + "api/getStoreHippoOrdersByStatus?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId + "&status=" + status + "&storeId=" + storeId, { headers: this.header1 });
  }

  toGetSnapdealOrder(accountOwnerId, organizationId, status, storeId) {
    return this.http.get(environment.apiUrl + "api/toGetSnapdealOrders/" + accountOwnerId + "?organizationId=" + organizationId + "&orderStatus=" + status + "&storeId=" + storeId, { headers: this.header1 });
  }

  getOrdersFromFlipkartStatus(accountOwnerId, fromDate = '', organizationId, status, storeId, toDate = '') {
    return this.http.get(environment.apiUrl + "api/getOrdersFromFlipkart?accountOwnerId=" + accountOwnerId + "&fromDate=" + fromDate + "&organizationId=" + organizationId + "&status=" + status + "&storeId=" + storeId + "&toDate=" + toDate, { headers: this.header1 });
  }

  getCarrierList(accountOwnerId, status, organizationId) {
    return this.http.get(environment.apiUrl + "api/getCarrierList?accountOwnerId=" + accountOwnerId + "&status=" + status + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  adminGetCarrierList(status, organizationId) {
    return this.http.get(environment.apiUrl + "api/getCarrierList?status=" + status + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  getCarrierInfoById(accountOwnerId, carrierId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getCarrierInfoById?accountOwnerId=" + accountOwnerId + "&carrierId=" + carrierId + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  adminGetCarrierInfoById(carrierId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getCarrierInfoById?carrierId=" + carrierId + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  deleteCarrierInfo(accountOwnerId, carrierId, organizationId) {
    return this.http.get(environment.apiUrl + "api/deleteCarrierInfo?accountOwnerId=" + accountOwnerId + "&carrierId=" + carrierId + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  adminDeleteCarrierInfo(carrierId, organizationId) {
    return this.http.get(environment.apiUrl + "api/deleteCarrierInfo?carrierId=" + carrierId + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  getDistinctStates() {
    return this.http.get(environment.apiUrl + "api/getDistinctStates", { headers: this.header1 });
  }

  getDistinctCity() {
    return this.http.get(environment.apiUrl + "api/getDistinctCities", { headers: this.header1 });
  }

  getCityAndStateByPinCode(zip) {
    return this.http.get(environment.apiUrl + "api/getStatesAndCityUsingPincode?zip=" + zip, { headers: this.header1 });
  }

  getAdminUserById(userId, orgId) {
    return this.http.get(environment.apiUrl + "api/getAdminUserById/" + userId + "?organizationId=" + orgId, { headers: this.header1 });
  }

  getSupportTicketById(ticketId,userId) {
    return this.http.get(environment.apiUrl + "api/getSupportTicketById/" + ticketId + "?userId=" + userId, { headers: this.header1 });
  }

  getMagentoStatuses(accountOwnerId, storeId) {
    return this.http.get(environment.apiUrl + "api/getMagentoStatuses?accountOwnerId=" + accountOwnerId + "&storeId=" + storeId, { headers: this.header1 });
  }

  getAccessKeyById(id) {
    return this.http.get(environment.apiUrl + "api/getAccessKeyById/" + id, { headers: this.header1 });
  }

  toGetAllMagentoProducts(accountOwnerId, noOfProducts, organizationId, storeId) {
    return this.http.get(environment.apiUrl + "api/toGetAllMagentoProducts/" + accountOwnerId + "?noOfProducts=" + noOfProducts + "&organizationId=" + organizationId + "&storeId=" + storeId, { headers: this.header1 });
  }

  /*
  http://localhost:8080/api/getMagentoStatuses?accountOwnerId=1&storeId=8
    testCarrierConnection(accountOwnerId, carrierId,organizationId) {
     return this.http.get(environment.apiUrl + "api/testCarrierConnection?accountOwnerId=" + accountOwnerId + "&carrierId=" + carrierId + "&organizationId=" + organizationId, { headers: this.header1 });
   } */

  getAddressByAddressId(addressId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getAddressByAddressId/" + addressId + "?organizationId=" + organizationId, { headers: this.header1 });
  }

  getShipmentDataById(shipmentHeaderId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getShipmentDataById/" + shipmentHeaderId + "?organizationId=" + organizationId, { headers: this.header1 });
  }

  toSyncNowStoreOrdersOrderId(sellerId, accountOwnerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/toSyncNowStoreOrders/" + sellerId + "?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  getOrderByAOSeller(accountOwnerId, orderStatus, organizationId, sellerId) {
    return this.http.get(environment.apiUrl + "api/getOrderByAOSeller?accountOwnerId=" + accountOwnerId + "&orderStatus=" + orderStatus + "&organizationId=" + organizationId + "&sellerId=" + sellerId, { headers: this.header1 });
  }

  getOrderDataById(headerId, accountOwnerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getOrderDataById/" + headerId + "?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId, { headers: this.header1 });
  }
  getOrderDataByIdPublic(headerId, accountOwnerId, organizationId) {
      return this.http.get(environment.apiUrl + "api/public/getOrderDataById/" + headerId + "?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId, {headers: this.header1});
    }

  getOrderDataByAdminId(headerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getOrderDataById/" + headerId + "?organizationId=" + organizationId, { headers: this.header1 });
  }

  createInvoiceForAccountOwner(accountOwnerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/createInvoiceForAccountOwner?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  getAllProductSeller(accountOwnerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getAllProductCategories?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  getOrderPreferenceValues() {
    return this.http.get(environment.apiUrl + "api/getOrderPreferenceValues", { headers: this.header1 });
  }

  getTrackingMenuLi(accountOwnerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getTrackingMenuList?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  getTrackingMenuLiPblic(accountOwnerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/public/getTrackingMenuList?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId, { headers: this.header1 });
  }

  getAvailableTrackingNumberDetails(carrierCode) {
    return this.http.get(environment.apiUrl + "api/getAvailableTrackingNumberDetails?carrierCode=" + carrierCode, { headers: this.header1 });
  }

  getInvoicesByInvoiceType(invoiceType) {
    return this.http.get(environment.apiUrl + "api/getInvoicesByInvoiceType?invoiceType=" + invoiceType, { headers: this.header1 });
  }

  getCreditTransactions() {
    return this.http.get(environment.apiUrl + "api/getCreditTransactions", { headers: this.header1 });
  }

  getCreditTransactionAmount() {
    return this.http.get(environment.apiUrl + "api/getCreditTransactionAmount", { headers: this.header1 });
  }

  getShipmentsByCarriers() {
    return this.http.get(environment.apiUrl + "api/getShipmentsByCarriers", { headers: this.header1 });
  }

  getCreditTransactionReports(fromDate, toDate) {
    return this.http.get(environment.apiUrl + "api/getCreditTransactionReports?fromDate=" + fromDate + "&toDate=" + toDate, { headers: this.header1 });
  }

  getCodOrdersForFinance(accountOwnerId, orderType, organizationId, status) {
    return this.http.get(environment.apiUrl + "api/getOrderConsignmentsByStatusCod?accountOwnerId=" + accountOwnerId + "&orderType=" + orderType + "&organizationId=" + organizationId + "&status=" + status, { headers: this.header1 });
  }

  getGoogleSheet(accountOwnerId, organizationId, storeId) {
    return this.http.get(environment.apiUrl + "api/getGoogleSheet?accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId + "&storeId=" + storeId, { headers: this.header1 });
  }

  getOrderByStore() {
    return this.http.get(environment.apiUrl + "api/getOrderByStore", { headers: this.header1 });
  }

  getTopFiveOrderDeliveredLocations() {
    return this.http.get(environment.apiUrl + "api/getTopFiveOrderDeliveredLocations", { headers: this.header1 });
  }

  organizationsTop5Products() {
    return this.http.get(environment.apiUrl + "api/top-five-products", { headers: this.header1 });
  }

  getGoogleSheetDataValidate(accountOwnerId, connectionName, organizationId, sheetId, sheetName) {
    return this.http.get(environment.apiUrl + "api/google-sheets/validate?accountOwnerId=" + accountOwnerId + '&connectionName=' + connectionName + '&organizationId=' + organizationId + '&sheetId=' + sheetId + '&sheetName=' + sheetName, { headers: this.header1 });
  }

  getOrderCountByCustomer(accountOwnerId, organizationId) {
    return this.http.get(environment.apiUrl + "api/getOrderCountByCustomer?accountOwnerId=" + accountOwnerId + '&organizationId=' + organizationId, { headers: this.header1 });
  }

  cancelReturnOrderRequest(returnOrderHeaderId,query){
  return this.http.get(environment.apiUrl + "api/return-orders/"+ returnOrderHeaderId + "/cancel" , {params : query,headers : this.header1});
  }

  updateGoogleSheetData(storeId, accountOwnerId, organizationId){
  return this.http.get(environment.apiUrl + "api/writeDataIntoGoogleSheet?storeId=" + storeId + "&accountOwnerId=" + accountOwnerId + "&organizationId=" + organizationId, { headers: this.header1 });
  }

 getCODOrderSummaryData(accountOwnerId) {
  return this.http.get(environment.apiUrl + "api/getCODOrdersSummaryData?accountOwnerId=" + accountOwnerId, { headers: this.header1});
 }
}
